export default __webpack_public_path__ + "static/media/ico-social.1c9b63d5.svg";